import { Component, Input } from '@angular/core';
import { AppSettings } from '../../app.settings';

@Component({
	selector: 'warning-info-message',
	template: require('./warning-info-message.component.html'),
})
export class WarningInfoMessageComponent {
	@Input() isVisible: boolean = true;
	@Input() warningMessage: string = '';
	public isRebrading = AppSettings.isRebrading;

	constructor() {}

	public close(): void {
		this.isVisible = !this.isVisible;
	}
}
